import PropTypes from 'prop-types';
import classNames from 'classnames';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ className, children, ...props }) => (
  <div className={classNames('layout', className)} {...props}>
    <Header />
    <main className="main">
      {children}
    </main>
    <Footer />
  </div>
);

Layout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Layout;
